export const breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '960px',
  xl: '1280px',
  '2xl': '1536px',
};
